const WIDTH_OPTIONS = [
  "Under 6 ft",
  "6 – 8 ft",
  "8 – 10 ft",
  "10 – 12 ft",
  "12 – 16 ft",
  "16 – 20 ft",
  "20 – 30 ft",
  "30 ft or wider",
  "Not sure — approximate is fine",
];

const HEIGHT_OPTIONS = [
  "Under 7 ft",
  "7 – 8 ft",
  "8 – 9 ft",
  "9 – 10 ft",
  "10 – 12 ft",
  "12 – 14 ft",
  "14 ft or taller",
  "Not sure — approximate is fine",
];

const PROJECTION_OPTIONS = [
  "Under 3 ft",
  "3 – 4 ft",
  "4 – 6 ft",
  "6 – 8 ft",
  "8 – 10 ft",
  "10 – 12 ft",
  "12 ft or more",
  "Not sure — approximate is fine",
];

const SERIES_OPTIONS = [
  { value: "Alamo Series — Residential", label: "Alamo Series™ — Residential" },
  { value: "Longhorn Series — Commercial", label: "Longhorn Series™ — Commercial" },
  { value: "Rio Grande Series — Hospitality (Hotels & Resorts)", label: "Rio Grande Series™ — Hospitality (Hotels & Resorts)" },
  { value: "Republic Series — Government / Schools", label: "Republic Series™ — Government / Schools" },
];

const FABRIC_OPTIONS = [
  "Sunbrella®",
  "Tempotest® Shade",
  "Serge Ferrari 502 (Waterproof)",
  "Help me decide",
];

export const AWNING_EXTRA_FIELDS_SUMMARY = [
  { name: "awningWidth", label: "How Wide" },
  { name: "awningHeight", label: "How Tall in Back" },
  { name: "awningProjection", label: "How Far Out From Wall" },
  { name: "awningSeries", label: "Series / Market", multiple: true },
  { name: "awningFabric", label: "Preferred Fabric" },
];

export function AwningExtras({ defaultSeries = [] }: { defaultSeries?: string[] } = {}) {
  const selectClass = "w-full border border-input bg-white px-4 py-3 text-sm focus:border-navy-deep focus:outline-none";
  return (
    <div className="space-y-4 border-l-4 border-navy-deep/20 bg-cream/40 p-4">
      <p className="text-xs text-navy-deep/70">
        Approximate sizes are totally fine — this just gets the process started. We'll confirm exact measurements on-site.
      </p>
      <div className="grid gap-4 sm:grid-cols-3">
        <div>
          <label htmlFor="awningWidth" className="block text-xs font-semibold uppercase tracking-wider text-navy-deep">How Wide?</label>
          <select id="awningWidth" name="awningWidth" defaultValue="" className={`mt-1 ${selectClass}`}>
            <option value="" disabled>Select width…</option>
            {WIDTH_OPTIONS.map((o) => <option key={o} value={o}>{o}</option>)}
          </select>
        </div>
        <div>
          <label htmlFor="awningHeight" className="block text-xs font-semibold uppercase tracking-wider text-navy-deep">How Tall in Back?</label>
          <select id="awningHeight" name="awningHeight" defaultValue="" className={`mt-1 ${selectClass}`}>
            <option value="" disabled>Select height…</option>
            {HEIGHT_OPTIONS.map((o) => <option key={o} value={o}>{o}</option>)}
          </select>
        </div>
        <div>
          <label htmlFor="awningProjection" className="block text-xs font-semibold uppercase tracking-wider text-navy-deep">How Far Out From Wall?</label>
          <select id="awningProjection" name="awningProjection" defaultValue="" className={`mt-1 ${selectClass}`}>
            <option value="" disabled>Select projection…</option>
            {PROJECTION_OPTIONS.map((o) => <option key={o} value={o}>{o}</option>)}
          </select>
        </div>
      </div>

      <div className="border border-navy-deep/20 bg-white p-4">
        <div className="text-xs font-semibold uppercase tracking-wider text-navy-deep">Photos to attach (below)</div>
        <ul className="mt-2 space-y-1 text-sm text-navy-deep/80">
          <li>• Right-side photo</li>
          <li>• Left-side photo</li>
          <li>• Front-facing photo</li>
          <li>• <strong>For an existing awning re-cover:</strong> a photo of the underneath / frame</li>
        </ul>
        <p className="mt-2 text-xs text-navy-deep/60">Use the "Attach Photos / Files" button further down to upload.</p>
      </div>

      <fieldset className="border border-navy-deep/20 bg-white p-4">
        <legend className="px-2 text-xs font-semibold uppercase tracking-wider text-navy-deep">Which series fits your project?</legend>
        <div className="mt-1 grid gap-2 sm:grid-cols-2">
          {SERIES_OPTIONS.map((s) => (
            <label key={s.value} className="flex items-start gap-2 text-sm text-navy-deep">
              <input type="checkbox" name="awningSeries" value={s.value} defaultChecked={defaultSeries.includes(s.value)} className="mt-1 h-4 w-4 border-navy-deep/40 text-navy-deep focus:ring-navy-deep" />
              <span>{s.label}</span>
            </label>
          ))}
        </div>
      </fieldset>

      <div>
        <label htmlFor="awningFabric" className="block text-xs font-semibold uppercase tracking-wider text-navy-deep">Preferred Fabric</label>
        <select id="awningFabric" name="awningFabric" defaultValue="" className={`mt-1 ${selectClass}`}>
          <option value="" disabled>Select fabric…</option>
          {FABRIC_OPTIONS.map((o) => <option key={o} value={o}>{o}</option>)}
        </select>
      </div>
    </div>
  );
}
